module.exports = __webpack_public_path__ + "static/media/empty_cart.b8f2fda7.webp";